import { Pipe, PipeTransform } from '@angular/core';
import { AlarmNotify } from 'src/app/core/models/alarms/alarm-notify.model';

@Pipe({
    name: 'alarmsubfilter'
})
export class AlarmSubscriptionFilterPipe implements PipeTransform {
    transform(alarmSubs: AlarmNotify[], searchText: string): any[] {
        if (!alarmSubs) {
            return [];
        }
        if (!searchText) {
            return alarmSubs;
        }
        searchText = searchText.toLowerCase();
        return alarmSubs.filter(alarmSub => {
            return alarmSub.destination.toLowerCase().includes(searchText) || alarmSub.alarmType?.name.toLowerCase().includes(searchText);
        });
    }
}
